const lang = {
	EN: {
		headerTitile: 'BAGS AND ACCESSORIES FROM ITALY',
		descriptionTitile: '95% of buyers returned with the words “I want more!”',
		headerBrandSection: 'BRANDS',
		newCollection: 'COLLECTION | NEW',
		seeAll: 'SHOW ALL',
		feedbackTitile: 'BUYER REVIEWS',
		colortile: 'COLOR',
		sizetile: 'Size',
		addbaskettile: 'Add to cart',
		tobaskettile: 'in the basket',
		nameserarch: 'Name, Brand, Category...',
		otmena: 'cancel',
		r: '₽'
	},
	'': {
		headerTitile: 'СУМКИ И АКСЕССУАРЫ ИЗ ИТАЛИИ',
		descriptionTitile: '95% покупателей вернулись со словами «хочу ещё!»',
		headerBrandSection: 'БРЕНДЫ',
		newCollection: 'КОЛЛЕКЦИЯ | НОВИНКИ',
		seeAll: 'ПОКАЗАТЬ ВСЕ',
		feedbackTitile: 'ОТЗЫВЫ ПОКУПАТЕЛЕЙ',
		colortile: 'ЦВЕТ',
		sizetile: 'РАЗМЕР',
		addbaskettile: 'в корзину',
		tobaskettile: 'в корзине',
		nameserarch: 'Название, Бренд, Категория...',
		otmena: 'Отмена',
		r: '₽'
	},
	KZ: {
		headerTitile: 'ИТАЛИЯДАН КЕЛГЕН СҮМКТЕР МЕН АКСЕССУАРЛАР',
		descriptionTitile:
			'Сатып алушылардың 95%-ы «Мен көбірек алғым келеді!» деген сөздермен оралды.',
		headerBrandSection: 'БРЕНДТЕР',
		newCollection: 'ЖИНАҚ | ЖАҢА',
		seeAll: 'БАРЛЫҒЫН КӨРСЕТУ',
		feedbackTitile: 'САТЫП АЛУШЫ ПІКІРЛЕР',
		colortile: 'ТҮС',
		sizetile: 'өлшемі',
		addbaskettile: 'Себетке қосу',
		tobaskettile: 'себетке',
		nameserarch: 'Аты, Бренд, Санат...',
		otmena: 'жою',
		r: '₸'
	},
	ARM: {
		headerTitile: 'Իտալիայից գործված պայուսակներ և աքսեսուարներ',
		descriptionTitile: 'Գնորդների 95%-ը վերադարձել է «Ես ավելին եմ ուզում» բառերով:',
		headerBrandSection: 'ԲՐԵՆԴՆԵՐ',
		newCollection: 'ЖИНАҚ |: ЖАҢА:',
		seeAll: 'ՑՈՒՅՑ ՏԱԼ ԱՄԲՈՂՋԸ',
		feedbackTitile: 'ԳՆՈՐԴԻ ԿԱՐԾԻՔՆԵՐ',
		colortile: 'ԳՈՒՅՆ',
		sizetile: 'ՉԱՓԸ',
		addbaskettile: 'Ավելացնել քարտին',
		tobaskettile: 'զամբյուղի մեջ',
		nameserarch: 'Անունը, ապրանքանիշը, կատեգորիան...',
		otmena: 'չեղարկում',
		r: '֏'
	}
};

export { lang };
